import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  IconButton,
  Typography,
} from '@material-ui/core'
import PinDropOutlinedIcon from '@material-ui/icons/PinDropOutlined'
import { Skeleton } from '@material-ui/lab'
import { useState } from 'react'

import { useGetInfestationComparisonByFieldFromRegion } from '@/hooks/queries/use-get-infestation-comparison-by-field-from-region'

import { useCompareDiagnoses } from '../contexts/compare-diagnoses-context'
import { formatNumberToBR } from '../utils'
import { Header } from './components/header'
import { SummaryTableCompare } from './components/summary-table'
import { UnitToggle, UnitType } from './components/unit-toggle'
import { useStyles } from './styles'

export default function LateralPanelCompare() {
  const classes = useStyles()
  const [selectedUnit, setSelectedUnit] = useState<UnitType>('percentage')

  const {
    regionId,
    fieldIds,
    baseDiagnosisId,
    compareDiagnosisId,
    setZoomFieldId,
  } = useCompareDiagnoses()

  const { data } = useGetInfestationComparisonByFieldFromRegion(
    regionId,
    fieldIds,
    baseDiagnosisId,
    compareDiagnosisId,
  )

  return (
    <div>
      <Header />
      {baseDiagnosisId && compareDiagnosisId && (
        <div className={classes.container}>
          {!data ? (
            <Box display='flex' flexDirection='column' gridGap='8px'>
              {Array.from({ length: 4 }).map((_, i) => (
                <Skeleton
                  key={i}
                  variant='text'
                  width='100%'
                  height={i === 0 ? '400px' : '56px'}
                  style={{ transform: 'initial' }}
                />
              ))}
            </Box>
          ) : (
            <>
              <UnitToggle
                selectedUnit={selectedUnit}
                onUnitChange={setSelectedUnit}
              />

              {data.fields_comparison.map((fieldData, index) => (
                <Accordion
                  key={fieldData.field_id}
                  className={classes.accordion}
                  defaultExpanded={index === 0}
                >
                  <AccordionSummary className={classes.accordionSummary}>
                    <Typography variant='body2'>
                      {fieldData.field_name}
                    </Typography>
                    <div>
                      <Typography
                        variant='inherit'
                        className={classes.areaInfo}
                      >
                        Área: {formatNumberToBR(fieldData.field_area.ha)} ha (
                        {formatNumberToBR(fieldData.field_area.pc)}%)
                      </Typography>
                      <IconButton
                        aria-label='Localizar campo'
                        size='small'
                        onClick={(e) => {
                          e.stopPropagation()
                          setZoomFieldId(fieldData.field_id)
                        }}
                      >
                        <PinDropOutlinedIcon
                          fontSize='small'
                          color='secondary'
                        />
                      </IconButton>
                    </div>
                  </AccordionSummary>

                  <AccordionDetails className={classes.accordionDetails}>
                    <SummaryTableCompare
                      field={fieldData}
                      selectedUnit={selectedUnit}
                      layerColors={data.layer_colors}
                      baseDiagnosisDate={data.base_diagnosis.date}
                      compareDiagnosisDate={data.comparison_diagnosis.date}
                    />
                  </AccordionDetails>
                </Accordion>
              ))}
            </>
          )}
        </div>
      )}
    </div>
  )
}
